import { CancellablePromise } from '@lifaon/observables';
import { ROUTE_PRIVATE } from './privates';
import { ConstructRoute } from './constructor';
import { ResolvableTree } from '../resolvable-tree/implementation';
import { CreateResolvableTreeResolver } from '../resolvable-tree/functions';
import { $super } from '../../misc/instance/snippets';
export function CreateRouteResolver() {
    return CreateResolvableTreeResolver({
        resolve(options) {
            const instance = this;
            const privates = instance[ROUTE_PRIVATE];
            const normalizedOptions = options;
            const path = privates.pathMatcher.exec(normalizedOptions.path);
            if (path === null) {
                return CancellablePromise.resolve({ resolved: false }, normalizedOptions);
            }
            else {
                return privates.resolve.call(instance, normalizedOptions)
                    .then((resolved) => {
                    const childrenOptions = resolved
                        ? ({
                            ...normalizedOptions,
                            path: path.remaining,
                        })
                        : void 0;
                    const resolvePathOptions = childrenOptions;
                    return {
                        resolved,
                        childrenOptions,
                        resolvePathOptions,
                    };
                });
            }
        },
        resolvePath(options, path) {
            const instance = this;
            return CancellablePromise.try(() => {
                const isFinalRoute = ((options.path === '')
                    && (instance.exec !== null));
                if (path.length === 0) {
                    if (isFinalRoute) {
                        return [instance];
                    }
                    else {
                        return [];
                    }
                }
                else {
                    return [instance].concat(path);
                }
            }, options);
        }
    });
}
const ROUTE_RESOLVER = CreateRouteResolver();
export function RouteGetPathMatcher(instance) {
    return instance[ROUTE_PRIVATE].pathMatcher;
}
export function RouteGetExec(instance) {
    return instance[ROUTE_PRIVATE].exec;
}
export class Route extends ResolvableTree {
    constructor(path, options = {}) {
        const _options = {
            ...options,
            resolve: ROUTE_RESOLVER,
        };
        super(_options);
        ConstructRoute(this, path, options);
    }
    get children() {
        return $super(this, ResolvableTree).get('children');
    }
    get pathMatcher() {
        return RouteGetPathMatcher(this);
    }
    get exec() {
        return RouteGetExec(this);
    }
    resolve(options) {
        return super.resolve(options);
    }
}
//# sourceMappingURL=implementation.js.map